import { Action } from '../../definitions/types';
import * as Actions from '../actions/actions-consts';

export default function skipTemplateView(
  state: boolean = false,
  action: Action<any> // tslint:disable-line no-any
): boolean {
  switch (action.type) {
    case Actions.SKIP_TEMPLATE_VIEW:
      return true;
    default:
      return state;
  }
}
